interface Config {
  APP_VERSION: string;
  APP_TITLE: string;
  AUTH_PATH_PREFIX: string;
  SOCKET_PATH: string;
  SOCKET_NAMESPACE: string;
  API_URL?: string;
  API_BE_URL: string;
  DATA_TABLE_SEARCH_DELAY: number;
  USER_IDLE_DELAY: number;
  CHAT_MAX_FILES: number;
  CHAT_MAX_FILE_SIZE: number;
  PHONE_NR_OF_DIGITS: number;
  GTM_ID?: string;
  [key: string]: any;
}

let config: Config = {} as Config;

const prefix = 'VITE_';

for (const [key, value] of Object.entries(import.meta.env)) {
  if (!key.startsWith(prefix)) {
    continue;
  }
  const confKey = key.replace(prefix, '');
  config[confKey] = value;
}

config = {
  ...config,
  APP_VERSION: '1.27.0',
  APP_TITLE: 'Maverick Signings',
  // refresh cookie is available in paths prefixed with this value
  // must match backend value
  AUTH_PATH_PREFIX: '/auth',
  // socket connection requests are sent to this backend path
  // must match backend value
  SOCKET_PATH: '/be/socket.io/',
  // socket client will connect to this namespace by default
  // must be a valid backend namespace
  SOCKET_NAMESPACE: 'be',
  // api urls
  API_BE_URL: (config.API_URL as string || '') + '/be',
  // delay after which the search query is sent
  DATA_TABLE_SEARCH_DELAY: 1000,
  // number of seconds after which an inactive user is considered idle
  USER_IDLE_DELAY: 180,
  // max number of images uploaded concurrently in chat
  CHAT_MAX_FILES: 3,
  // max accepted size (in bytes) of images uploaded in chat
  CHAT_MAX_FILE_SIZE: 5242880, // = 5 MB
  // number of digits required for a valid phone number
  PHONE_NR_OF_DIGITS: 10,
};

export default config as Config;
